import {UseMutateFunction} from 'react-query'

import styles from './DrawdownsSurplusModal.module.scss'
import {Button, Modal} from 'common/components'
import {
  formatDate,
  formatMoney,
  changeForecastDrawdownItem,
  getNewForecastItemFormValues,
  getNewSortedForecastByChangeItem,
} from 'common/helpers'
import {ForecastFormItem} from 'common/types'

interface DrawdownsSurplusModalProps {
  surplus: number
  isOpen: boolean
  values: any
  forecastItem: ForecastFormItem
  loanValue: number
  projectUuid: string
  requestUuid?: string
  forecast: ForecastFormItem[]
  onClose: () => void
  onSingleItemChange: (values: any) => void
  updateForecast: UseMutateFunction<any, any, any, unknown>
}

export default function DrawdownsSurplusModal({
  surplus,
  isOpen,
  values,
  forecastItem,
  forecast,
  loanValue,
  projectUuid,
  requestUuid,
  onClose,
  onSingleItemChange,
  updateForecast,
}: DrawdownsSurplusModalProps) {
  const handleChange = () => {
    onClose()
    onSingleItemChange(values)
  }

  const handleAllocate = () => {
    onClose()
    const newValues = getNewForecastItemFormValues(values, forecastItem)
    const sortedNewForecast = getNewSortedForecastByChangeItem(
      newValues,
      forecast
    )
    const newForecast = changeForecastDrawdownItem({
      loanValue,
      hasForecast: true,
      forecast: sortedNewForecast,
      drawdown: newValues,
    })
    const newForecastToServer = newForecast.map((item) => {
      const date = formatDate(item.date, 'server')
      if (!forecastItem && item.uuid === newValues.uuid)
        return {
          date,
          type: item.type,
          amount: item.amount,
        }
      return {
        date,
        uuid: item.uuid,
        amount: item.amount,
      }
    })
    const forecastServerData: any = {
      project: projectUuid,
      items: newForecastToServer,
    }
    if (requestUuid) {
      forecastServerData.loanRequest = requestUuid
    }
    return updateForecast(forecastServerData)
  }

  const surplusString = formatMoney(surplus, {cents: true})

  return (
    <Modal
      title={`Difference is ${surplusString}`}
      width={486}
      open={isOpen}
      onCancel={onClose}
    >
      <p className={styles.text}>
        You have {surplusString} available from your loan amount for the
        forecast. We can allocate this difference automatically to all future
        estimated drawdowns. Would you like to do that?
      </p>
      <div className={styles.actions}>
        <Button className={styles.button} onClick={handleChange}>
          No, thanks
        </Button>
        <Button className={styles.button} onClick={handleAllocate}>
          Yes, allocate
        </Button>
      </div>
    </Modal>
  )
}
